export enum QueryKeys {
	CURRENT_USER = 'current-user',
	CURRENT_USER_ERROR_HANDLING = 'current-user-error-handling',
	NMI = 'nmi',
	GET_CITY_DETAILS = 'city-details',
	GET_CITY_DETAILS_GUEST = 'city-details-guest',
	GET_COURSES = 'courses',
	GET_PRECISELY_PROPERTY_DETAILS = 'precisely-property-details',
	GET_PROPERTY_NOTES = 'property-notes',
	GET_TOMS_AI_PROPERTY_DETAILS = 'toms-ai-property-details',
	GET_TOMS_AI_PROPERTY_ANALYSIS_ACCESS = 'toms-ai-property-analysis-access',
	GET_DEAL_EXPLORER_PROPERTIES = 'deal-explorer-properties',
	GET_GUEST_DEAL_EXPLORER_PROPERTIES = 'guest-deal-explorer-properties',
	GET_DEAL_EXPLORER_MAP = 'deal-explorer-map',
	GET_DEAL_EXPLORER_CARDS = 'deal-explorer-cards',
	GET_CALCULATOR_PRESET = 'calculator-preset',
	GET_DEFAULT_PROPERTIES = 'default-properties',
	GET_DEFAULT_PROPERTIES_GUEST = 'default-guest-properties',
	GET_COURSE = 'course',
	GET_COURSE_SECTION = 'course-section',
	GET_PROPERTY_DETAILS_BY_ID = 'property-details-by-id',
	GET_FMR_DETAILS = 'fmr-details',
	GET_FMR_MAP = 'fmr-map',
	GET_FMR_LIST = 'fmr-list',
	GET_VIDEO_LINK = 'video-link',
	GET_CITY_RESEARCH = 'city-research',
	GET_CITY_RESEARCH_GUEST = 'city-research-guest',
	GET_PROPERTY_RESEARCH = 'property-research',
	FETCH_CITIES = 'fetch-cities',
	FETCH_COUNTIES = 'fetch-counties',
	FETCH_STATES = 'fetch-states',
	SEARCH_GEOGRAPHY = 'search-geography',
	FMR_AUTOCOMPLETE_LIST = 'fmr-autocomplete-list',
	UNREAD_SIDEBAR_COUNTER = 'unread-sidebar-counter',
	UNREAD_TABS_COUNTER = 'unread-tabs-counter',
	GET_CRIMES_BY_COORDINATES = 'crimes-by-coordinates',
	// Used by the stashed Property Details tab rework; kept so the stash applies cleanly.
	GET_PROPERTY_CRIME_SUMMARY = 'get-property-crime-summary',
	GET_RANDOM_PROMOTED_VENDORS = 'get-random-promoted-vendors',
	GET_PROMOTED_VENDORS = 'get-promoted-vendors',
	GET_VENDORS = 'get-vendors',
	GET_VENDORS_STATES = 'get-vendors-states',
	GET_VENDORS_CITIES = 'get-vendors-cities',
	GET_VENDOR_OFFICE_DETAILS_BY_ID = 'get-vendor-office-details-by-id',
	GET_VENDOR_CATEGORIES = 'get-vendor-categories',
	GET_VENDOR_SERVICES = 'get-vendor-services',
	GET_PROPERTY_PRICE_HISTORY = 'get-property-price-history',
	GET_PROPERTY_TAX_HISTORY = 'get-property-tax-history',
	GET_PROPERTY_HISTORY_HEAD = 'get-property-history-head',
	GET_DEAL_EXPLORER_RECOMMENDED_PROPERTIES = 'get-deal-explorer-recommended-properties',
	GET_USER_INTRODUCTION = 'get-user-introduction',
	GET_QUICK_START_INTRODUCTION_VIDEO = 'get-quick-start-introduction-video',
	GET_WEBINAR_LINKS = 'get-webinar-links',
	GET_CRIME_LOOKUP_PROPERTIES = 'get-crime-lookup-properties',
	GET_CRIME_LOOKUP_PROPERTY_CRIMES = 'get-crime-lookup-property-crimes',
	GET_CRIME_LOOKUP_PLACE_CRIMES = 'get-crime-lookup-place-crimes',
	GET_CRIME_LOOKUP_POPULAR_PLACES = 'get-crime-lookup-popular-places',
	GET_CRIME_LOOKUP_LATEST_LISTINGS = 'get-crime-lookup-latest-listings',
}
